import { State } from '@hookstate/core';
import { GameTypeNumbers } from '../components/GameType';
import { GameState } from '../stores/backend';

export const useGameType = (game: State<GameState>) =>
    parseInt(game.game_type.value.substring(0, 2)) as GameTypeNumbers;
